import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { CreateAgentModal } from "../../features/Agents/Components/CreateAgentModal";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { createAgentAction } from "../../features/Agents/redux/actions";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";

export const AgentsPage = () => {
  const dispatch = useAppDispatch();
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("krab");
  const { handleSelectObject } = useStorageObject(
    "krab",
    "krab",
    currentService,
  );
  const { handleCloseModal, handleOpenModal } = useAppModals();

  useServiceNavigate("krab", "krab");

  const handleCreateAgent = (objectName: string, agentName: string) => {
    dispatch(createAgentAction({ objectName, agentName })).unwrap();
  };

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() => handleOpenModal("create_agent_modal", null, "root")}
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"krab"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
      <CreateAgentModal
        subtype={"root"}
        handleCreateAgent={handleCreateAgent}
        closeModal={handleCloseModal}
      />
    </div>
  );
};
